<script>
import axios from "axios";
import Paginate from "vuejs-paginate";
import ListingItem from "./ListingItem.vue";
import ListingFilters from "./ListingFilters.vue";
import { debounce } from "../../utils/debounce.js";
import getParameter from "get-parameter";

export default {
  name: 'ListingPage',
  components: {
    ListingItem,
    ListingFilters,
    paginate: Paginate,
  },
  data() {
    return {
      currentFilters: [],
      filterResults: [],
      listingItems: [],
      selectedFilters: [],
      currentPage: [],
      parameters: [],
      noResults: true,
      showFilters: false,
      window: window,
      firstMobileTabItem: null,
      lastMobileTabItem: null,
      filterCategories: [],
      currentPageNum: 1,
      filtersAreSelected: false,
      showGrid: false,
      showFilter: true,
      search: "",
      inViewIndex: 11,
      popularSearches: [],
      filterCount: [],
      isMobile: false,
      loading: true,
      totalPages: 0,
    };
  },
  props: {
    dataUrl: String,
    popularSearchUrl: String,
    removeForProduction: false,
    mode: {
      type: String,
      default: 'products'
    }
  },
  beforeUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  computed: {
    pageCount: function() {
      if (this.filterResults.length) {
        return Math.ceil(this.filterResults.length / 11);
      } else {
        return 0;
      }
    },
    filteredList() {
      return this.currentPage.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    showingResults() {
      if (this.loading) {
        return "Searching for results&hellip;";
      } else {
        return (
          "Showing <strong>" +
          this.filterResults.length +
          "</strong> result" +
          (this.filterResults.length == 1 ? "" : "s")
        );
      }
    },
    showingUnformattedResults() {
      if (this.loading) {
        return "Showing results";
      } else {
        return (
          "Showing " +
          this.filterResults.length +
          " result" +
          (this.filterResults.length == 1 ? "" : "s")
        );
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    this.loading = true;
    this.showGrid = true;
    console.log(this.mode)
    if(this.mode === 'search') {
      this.showGrid = false;
    }
    axios.get(`${this.$props.dataUrl}`).then((response) => {
      this.parseSearchResults(response);
      this.generateFilterOptions(response.data.searchResults);
      this.loading = false;
    });
    const resetWindow = debounce(() => {
      this.window = window;
    });
    const toggleFilter = debounce(() => {
      if (this.window.document.body.clientWidth > 1024) {
        this.showFilters = true;
      } else {
        this.showFilters = false;
      }
    });
    const toggleView = debounce(() => {});
    this.firstMobileTabItem = document.querySelectorAll(
      "[data-first-focus]"
    )[0];
    this.lastMobileTabItem = document.querySelectorAll("[data-last-focus]")[0];
    toggleFilter();
  },
  watch: {
    showFilters(newVal, oldVal) {
      if (newVal && this.window.document.body.clientWidth < 1025) {
        this.applyTabTrap();
      } else {
        this.removeTabTrap();
      }
    },
    search(newVal, oldVal) {
      if (newVal === "") {
        this.applyFilters();
      }
    },
  },

  methods: {
    categoryExists(name) {
      return this.filterCategories.find((category) => {
        return category.name === name;
      });
    },
    onResize() {
      this.isMobile = window.innerWidth <= 1024;
    },
    performSearch(query) {
      window.location = "/search-results?searchquery=" + query;
      //Pass search string to new endpoint for popular collection
      if (!!this.popularSearchUrl)
        axios.get(`${this.$props.popularSearchUrl}`, {
          params: {
            searchquery: query,
          },
        });
    },
    performLocalSearch() {
      this.filterResults = [];
      this.applyFilters();
    },
    includesFilterCategory(filterName) {
      let hasFilter = false;
      this.filterCategories.forEach((category) => {
        if (category.name === filterName) {
          hasFilter = true;
          // console.log("we have this filter", hasFilter);
        }
      });

      return hasFilter;
    },
    addValuesToFilterCatgeory(filter) {
      const tmpCategories = [...this.filterCategories];
      tmpCategories.forEach((category, index) => {
        if (filter.name === category.name) {
          let isFoundIndex = category.values.findIndex((categoryValue) => {
            return categoryValue.title.indexOf(filter.value[0]) >= 0;
          });
          if (isFoundIndex < 0) {
            category.values.push({ title: filter.value[0], count: 1 });
          } else {
            category.values[isFoundIndex].count += 1;
          }

         
        }
      });
      this.filterCategories = [...tmpCategories];
    },
    updateFilterCounts(fromItems) {
      this.filterCategories.forEach((category) => {
        category.values.forEach((val) => {
          val.count = 0;
        });
      });
      fromItems.forEach((item, fIndex) => {
        if (item.filters) {
          item.filters.forEach((iFilter) => {
            this.filterCategories.forEach((category) => {
              if (category.name === iFilter.name) {
                category.values.forEach((catVal) => {
                  iFilter.value.forEach((val) => {
                    if (catVal.title === val) {
                      catVal.count += 1;
                    }
                  });
                });
              }
            });
          });
        }
      });
    },
    generateFilterOptions(fromItems) {
      this.filterCategories = [];
      fromItems.forEach((item, fIndex) => {
        if (item.filters) {
          item.filters.forEach((iFilter) => {
            if (this.includesFilterCategory(iFilter.name)) {
              this.addValuesToFilterCatgeory(iFilter);
            } else {
              this.filterCategories.push({
                name: iFilter.name,
                values: [
                  {
                    title: iFilter.value[0],
                    count: 1,
                  },
                ],
                selected: [],
              });
            }
          });

          //
          // filters.map(() = > {
          // console.log(filterCategory, 'category?')
          // if (!this.categoryExists(filterCategory.name)) {
          // this.addCategory(filterCategory);
          // }
          /*
            if (filterCategory.name === "Product Type") {
              if (filterCategory.value.length > 1) {
                filterCategory.value.map((cat, index) => {
                  if (index > 0) {
                    cat = "<span class='indent'>" + cat + "</span>";
                    filterCategory.value[index] = cat;
                  }
                })
              }
            } else {

            } */
          // });
        }
      });
    },
    parseSearchResults(response) {
      // this.listingItems = response.data.searchResults;
      this.listingItems = this.sortbyName(response.data.searchResults)
      this.filterResults = response.data.searchResults;
      this.popularSearches = response.data.popularSearches;

      //Reset padgination to default of 11
      
      if (this.showGrid) {
        this.inViewIndex = 9;
        this.currentPage = this.filterResults.slice(0, this.inViewIndex);
      } else {
        this.inViewIndex = 11;
        this.currentPage = this.filterResults.slice(0, this.inViewIndex);
      }
      this.currentPageNum = 1;

      //Clear filters and reset categories for new incoming data
      this.clearFilters();
      this.filterCategories = [];

      this.listingItems.forEach((item) => {
        if (item.extension) {
          item.extension = item.extension.toUpperCase();
        }
        if (item.fileSize) {
          var i = Math.floor(Math.log(item.fileSize) / Math.log(1024));
          item.fileSize =
            (item.fileSize / Math.pow(1024, i)).toFixed(2) * 1 +
            " " +
            ["B", "kB", "MB", "GB", "TB"][i];
        } else {
          item.fileSize = "0 KB";
        }
      });

      this.$nextTick(() => {
        this.filterResults.forEach((item, index) => {
          if (item.length) {
            this.filterResults.splice(index, 1);
          }
        });

        this.filterCategories.map((category) => {
          const currentParameter = [].concat(
            getParameter(
              category.name
                .toLowerCase()
                .replace(/(-)+/g, " ")
                .replace(/( )+/, "")
            ).split(",")
          );
          if (currentParameter.length > 0 && currentParameter[0] !== "") {
            currentParameter.map((value, index) => {
              this.toggleFilterByKeyValue(
                category.name,
                value.replace(/(-)+/g, " ")
              );
            });
          }
        });

        

        if (this.filterResults.length === 0) {
          
          this.filterResults = [].concat(this.listingItems);
          this.noResults = true;
        } else {
          this.noResults = false;
          if (this.showGrid) {
            this.totalPages = Math.ceil(this.filterResults.length / 9);
          } else {
            this.totalPages = Math.ceil(this.filterResults.length / 10);
          }
        }
      });
    },
    paginationCallback: function(pageNum) {
      this.currentPageNum = pageNum;
      this.currentPage = this.filterResults.slice(
        (pageNum - 1) * 10,
        pageNum * 10
      );
      
      //this.currentPage[this.currentPage.length - 1];
    },
    isSelectedKeyValue(key, value) {
      let matched = false;
      this.filterCategories.map((filterCategory) => {
        if (
          filterCategory.name === key &&
          filterCategory.selected.includes(value)
        ) {
          matched = true;
        }
      });
      return matched;
    },
    addCategory(category) {
      this.filterCategories.push({
        name: category.name,
        selected: [],
        value: [],
        count: 0,
      });
    },
    getItemFilterByName(item, key) {
      if (item.filters) {
        const returnedFilter = item.filters.find((filter) => {
          return filter.name.toLowerCase() === key.toLowerCase();
        });
        if (Array.isArray(returnedFilter.value)) {
          return returnedFilter.value.join(" , ");
        } else {
          return returnedFilter.value;
        }
      }
    },
    checkTabToFirst(event) {
      if (!event.shiftKey && event.key === "Tab") {
        event.preventDefault();
        this.tabToFirst();
      }
    },
    applyTabTrap() {
      document.body.setAttribute("data-modal-open", true);

      if (this.lastMobileTabItem) {
        this.lastMobileTabItem.addEventListener(
          "keydown",
          this.checkTabToFirst
        );
      }
    },
    removeTabTrap() {
      document.body.setAttribute("data-modal-open", false);

      if (this.lastMobileTabItem) {
        this.lastMobileTabItem.removeEventListener(
          "keydown",
          this.checkTabToFirst
        );
      }
    },
    tabToFirst() {
      const listboxSelects = [].slice.call(
        this.$el.querySelectorAll(".listing-filters__listbox-select")
      );
      if (this.filtersAreSelected === true) {
        this.firstMobileTabItem.focus();
      } else {
        listboxSelects[0].focus();
      }
    },
    tabToLast() {
      this.lastMobileTabItem.focus();
    },
    toggleFilterCategoryBoxes($event) {
      $event.stopImmediatePropagation();
      $event.preventDefault();
      const categoryBoxes = [].slice.call(
        this.$el.querySelectorAll(".listing-filters__listbox")
      );
      categoryBoxes.forEach((filterBox) => {
        filterBox.setAttribute("aria-expanded", "false");
      });
    },
    toggleFilterCategoryBox($event) {
      $event.stopImmediatePropagation();
      $event.preventDefault();
      const currentTarget = $event.currentTarget.parentElement;

      if (currentTarget.getAttribute("aria-expanded") === "true") {
        currentTarget.setAttribute("aria-expanded", "false");
      } else {
        currentTarget.setAttribute("aria-expanded", "true");
      }

      // hideOnClickOutside(currentTarget, () => {
      //      currentTarget.setAttribute('aria-expanded', 'false');
      // });

      if ($event.key === "Enter" || $event.key === "Tab") {
        $event.currentTarget.parentElement.setAttribute(
          "aria-expanded",
          "true"
        );
      }
    },
    hideFilterCategoryBox(event) {
      e.currentTarget.setAttribute("aria-expanded", "false");
    },
    toggleFilterByKeyValue(key, value, $event, remove = false) {
      if (key == "Resource Type" || key == "Filter") {
        this.clearFilters();
        $(".radio-selected").each(function() {
          $(this).removeClass("radio-selected");
        });
        if ($event) {
          $($event.target).addClass("radio-selected");
        }
      }
      if ($event) {
        $(".checkbox-selected u-font-noto-sans-bold").each(function() {
          $(this).removeClass("checkbox-selected u-font-noto-sans-bold");
        });
        $($event.target)
          .siblings(".count")
          .addClass("checkbox-selected u-font-noto-sans-bold");
        window.dataLayer = window.dataLayer || [];
        if (window.location.href.indexOf("search") > -1) {
          window.dataLayer.push({
            event: "filter",
            filter_type: "search",
            selection: value,
          });
        } else {
          window.dataLayer.push({
            event: "filter",
            filter_type: key,
            selection: value,
          });
        }
      }

      const convertedKey = key.toLowerCase();

      const convertedValue = value.title.toLowerCase();
      let correctedVal = "";
      let correctedKey = "";
      this.filterCategories.map((filterCategory) => {
        if (filterCategory.name.toLowerCase() === convertedKey) {
          //if (!)
          let isSelected = false;
          let selectedIndex = -1;
          filterCategory.selected.forEach((currentCategory, index) => {
            if (currentCategory.toLowerCase() === convertedValue) {
              selectedIndex = index;
              isSelected = true;
            }
          });

          if (isSelected) {
            filterCategory.selected.splice(selectedIndex, 1);
          } else {
            filterCategory.values.map((currentFilterValue) => {
              if (
                currentFilterValue.title.toLowerCase() === convertedValue &&
                !remove
              ) {
                filterCategory.selected.push(currentFilterValue.title);

                correctedVal = currentFilterValue.title;
                correctedKey = filterCategory.name;
              }
            });
          }
        }
      });

      let currentSelected = [].concat(this.selectedFilters);

      if (this.selectedFilters.length > 0) {
        if (
          this.selectedFilters.filter((selected) => {
            return (
              selected.name.toLowerCase() === convertedKey &&
              selected.value.toLowerCase() === convertedValue
            );
          }).length > 0
        ) {
          currentSelected = [].concat(
            currentSelected.filter((selected) => {
              return !(
                selected.name.toLowerCase() === convertedKey &&
                selected.value.toLowerCase() === convertedValue
              );
            })
          );
        } else {
          if (!remove) {
            currentSelected.push({ name: correctedKey, value: correctedVal, title: correctedVal });
          }
        }
      } else {
        if (!remove) {
          currentSelected.push({ name: correctedKey, value: correctedVal, title: correctedVal });
        }
      }

      this.selectedFilters = [].concat(currentSelected);
      

      this.filtersAreSelected = this.selectedFilters.length > 0;

      this.applyFilters();
    },
    sortbyName(arr) {
      
      const sorted = arr.sort((a, b)=> {
          return a.name.localeCompare(b.name)
      })
      
      return sorted
    },
    applyFilters() {
      this.filterResults = [];
      this.listingItems.map((item) => {
        let matched = false;
        if (item.filters) {
          item.filters.map((itemFilter) => {
            this.filterCategories.map((filterCategory) => {
              if (itemFilter.name === filterCategory.name) {
                if (Array.isArray(itemFilter.value)) {
                  filterCategory.selected.forEach((val) => {
                    if (itemFilter.value[0] === val) {
                      matched = true;
                    }
                  });
                  //if (filterCategory.selected)
                  /*if(itemFilter.values.includes() => {
                    if (filterCategory.selected.includes(filter)) {

                    }
                  });
                  */
                } else {
                  if (filterCategory.selected.includes(itemFilter.value)) {
                    matched = true;
                  }
                }
              }
            });
          });
        }

        if (matched) {
          this.filterResults.push(item);
          this.noResults = false;
        }
      });
      if (this.filterResults.length === 0) {
        this.filterResults = [].concat(this.listingItems);
        // this.noResults = true;
      } else {
        // this.noResults = false;
      }

      if (this.search !== "") {
        // console.log('lets try to apply the search')
        this.filterResults = this.filterResults.filter((result) => {
          let resultMatch = false;
          if (result.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
            resultMatch = true;
          }
          result.filters.forEach((filter) => {
            filter.value.forEach(val => {
              if(!resultMatch) {
                if(this.search.toLowerCase() === val.toLowerCase()) {
                  resultMatch = true;
                }
              }
            })
          });

          return resultMatch;
        });
      }
      if (this.filterResults.length === 0) {
        this.noResults = true;
      } else {
        this.noResults = false;
      }

      // this.filterResults = this.sortByName(this.filterResults);

      if(this.showGrid) {
        this.currentPage = this.filterResults.slice(0, 9);
        this.totalPages = Math.ceil(this.filterResults.length / 9);
      } else {
        this.currentPage = this.filterResults.slice(0, 10);
        this.totalPages = Math.ceil(this.filterResults.length / 10);
      }

      console.log(this.totalPages, 'total pages?')

      this.updateFilterCounts(this.filterResults);

      
      this.currentPageNum = 1;
    },
    clearFilters($event) {
      if ($event) {
        $(".radio-selected").each(function() {
          $(this).removeClass("radio-selected");
        });
        $($event.target).addClass("radio-selected");
      }
      $(".checkbox-selected").each(function() {
        $(this).removeClass("checkbox-selected u-font-noto-sans-bold");
      });
      this.filterResults = [];
      this.filterResults = [].concat(this.listingItems);
      this.selectedFilters = [];
      this.filtersAreSelected = false;
      // this.search = "";
      this.noResults = false;
      const tmpFilters = [...this.filterCategories];
      tmpFilters.map((filterCategory) => {
        filterCategory.selected = [];
      });
      this.filterCategories = [...tmpFilters];
      
      
      
      if(this.showGrid) {
        this.currentPage = this.filterResults.slice(0, 9);
        this.totalPages = Math.ceil(this.filterResults.length / 9);
        this.inViewIndex = 9;
      } else {
        this.currentPage = this.filterResults.slice(0, 10);
        this.totalPages = Math.ceil(this.filterResults.length / 10);
        this.inViewIndex = 10;
      }
      
      if (this.search !== "") {
        this.performLocalSearch();
      } else {
        this.generateFilterOptions(this.listingItems);
      }
    },
    getFilters(item, filterName) {
      return item.filters.find((filter) => {
        return filter.name === filterName;
      }).value;
    },
    nextPage(event) {
      event.preventDefault();
  
      if(this.showGrid) {
        this.inViewIndex += 9;
      } else {
        this.inViewIndex += 11;
      }
      
      this.currentPage = this.filterResults.slice(0, this.inViewIndex);
      // this.totalPages =  Math.ceil(this.filtersResults.length / 
      this.currentPageNum++;
      this.$nextTick(() => {
        const focusables = $('.result-card');
        focusables[this.inViewIndex - 10].focus();
        // console.log(focusables[this.inViewIndex - 10], 'last one?')
      })
    },
    
  },
};
</script>
